module.exports = __webpack_public_path__ + "img/rank-beginner.4c8128e1.png";